import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Navbar from '../components/Navbar';
import SiteFooter from '../components/SiteFooter';

/** Branded 404 in the Figma support-page idiom (floral hero texture, gold display heading). */
export default function NotFoundPage() {
  useEffect(() => {
    const prev = document.title;
    document.title = 'Page not found · SoulSathiya';
    return () => { document.title = prev; };
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Navbar />
      <main
        className="flex-1"
        style={{
          backgroundImage: 'url(/method-hero-bg-pattern.webp)',
          backgroundSize: '1440px auto',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center -62px',
        }}
      >
        <section className="flex flex-col items-center justify-center gap-6 text-center px-6 pt-[120px] pb-[140px]">
          <span className="inline-flex items-center justify-center gap-2 px-3 py-1 rounded-full text-sm leading-5 bg-white" style={{ color: '#0b1729' }}>
            <span className="w-2 h-2 rounded-full bg-primary" />
            404
          </span>
          <h1 className="font-heading font-medium text-4xl sm:text-[48px] leading-[1.15] sm:leading-[56px] tracking-[-0.96px] max-w-[740px]">
            <span className="text-primary">This page isn't here.</span>{' '}
            <span style={{ color: '#fff9ea' }}>The right one might be closer than you think.</span>
          </h1>
          <p className="text-lg leading-7 text-white max-w-[560px]">
            The link may be old or mistyped. Head back home, or start where most people do.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 items-center pt-2">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-1 px-5 py-4 rounded-xl text-base leading-6 font-medium w-full sm:w-auto"
              style={{ background: '#f1b200', color: '#0e1d33' }}
            >
              Back to home <ArrowRight className="w-5 h-5" strokeWidth={2} />
            </Link>
            <Link
              to="/register"
              className="inline-flex items-center justify-center px-5 py-4 rounded-xl text-base leading-6 font-medium w-full sm:w-auto"
              style={{ background: 'white', color: '#0e1d33' }}
            >
              Find my match — it's free
            </Link>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
